import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import $ from 'jquery';

const fileType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

class Util {
   getUsername() {
    return this.getCookie('userName');
  }
  exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  createCookie = (cookieName, cookieValue, daysToExpire) => {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + '=' + cookieValue + '; expires=' + date.toGMTString();
  };

  accessCookie = cookieName => {
    var name = cookieName + '=';
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) === 0)
        return temp.substring(name.length, temp.length);
    }
    return '';
  };

  getCookie = cname => {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  deleteCookie = name => {
    document.cookie =
      name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  compileTableHeder = MDBheaders => {
    const tableHeader = MDBheaders.map(item => {
      return {
        label: item[0],
        field: item[1],
        width: item[2]
      }
    });

    return tableHeader;
  }
  
  clearChooseFile = () => {
  if (document.getElementById("my_file_input") !== null) {
    document.getElementById("my_file_input").style.color =
    "transparent";
    document.getElementById("picking_label").style.display = "inline-block";
    document.getElementById("picking_label").innerHTML =
    "Select and Upload Picksheet";
    document.getElementById("picking_label").value = undefined;
  }
  document.getElementById("my_file_input").style.width = "26%";
  $(".upload_error").css('display', 'none');
  $(".upload_success").css('display', 'none');
  }
}

/*const username = this.getCookie('username');*/

const utilobj = new Util();
export default utilobj;

const userName = utilobj.getUsername();
console.log('Util userName:', userName);
export {userName}


